<template>
  <Popper placement="right">
    <i
      role="button"
      class="fa-solid fa-user px-2"
    ></i>
    <template #content>
      <table
        class="table table-striped"
      >
        <tbody>
        <tr
          v-for="(attachedDriver, attachedDriverIndex) in task.kierowcy"
          :key="attachedDriverIndex"
        >
          <td>{{ attachedDriverIndex + 1 }}.</td>
          <td> {{ attachedDriver.firstName }} {{ attachedDriver.surname }} </td>
          <td>
            <button
              class="btn btn-sm btn-danger"
              @click="detachDrivers(task.id, attachedDriver.id)"
            >
              Odepnij tego kierowcę
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="task.kierowcy.length > 0">
        <button class="btn btn-danger mt-1 mb-3" @click="detachTeam">Odepnij całą obsadę</button>
      </div>
      <form @submit.prevent="attachDriverToTask(task.id, this.selectedDriverId)">
        <label>
          Zawęź wyniki wpisując tekst:
          <input type="text" v-model="driversSearchText" class="form-control" @input="searchDrivers()">
        </label>
        <label
          class="d-block mt-2"
          v-if="foundDrivers.length === 0"
        >
          Dodaj nowego kierowcę z listy:
          <select
            class="d-inline form-select"
            v-model="selectedDriverId"
            required
          >
            <option
              :value="null"
              selected
            >
              -- wybierz kierowcę --
            </option>
            <option v-for="driver in drivers" :key="driver" :value="driver.id">
              {{ driver.surname }} {{ driver.firstName }}
            </option>
          </select>
        </label>
        <label
          class="d-block mt-2"
          v-else
        >
          Dodaj nowego kierowcę z listy:
          <select
            class="d-inline form-select"
            v-model="selectedDriverId"
            required
          >
            <option
              :value="null"
              selected
            >
              -- wybierz kierowcę --
            </option>
            <option v-for="driver in foundDrivers" :key="driver" :value="driver.id">
              {{ driver.surname }} {{ driver.firstName }}
            </option>
          </select>
        </label>
        <button
          class="btn btn-sm btn-success mt-2"
          type="submit"
        >
          Zatwierdź kierowcę
        </button>
      </form>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'

export default {
  name: 'AttachedDrivers',
  components: { Popper },
  props: ['task', 'drivers'],
  data () {
    return {
      driversSearchText: '',
      selectedDriverId: null,
      selectedTask: {},
      isLoading: false,
      foundDrivers: []
    }
  },
  methods: {
    async searchDrivers () {
      this.isLoading = true
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      const searchText = this.driversSearchText.trim()

      if (searchText !== '') {
        this.foundDrivers = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, config)).data.filter(driver => `${driver.firstName} ${driver.surname}`.toLowerCase().includes(searchText.toLowerCase()) || `${driver.surname} ${driver.firstName}`.toLowerCase().includes(searchText.toLowerCase()))
      }

      this.isLoading = false
    },
    async attachDriverToTask (taskId, driverId) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = { drivers: [driverId] }

      try {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Drivers`, postData, config)
        await Swal.fire('Dodano kierowcę do zlecenia', '', 'success')
        emitter.emit('taskChanged', { taskId: this.task.id })
      } catch (e) {
        if (e.response.status === 400) {
          const dialogResult = await Swal.fire({
            title: 'Kierowca jest już dodany do innego zlecenia. Czy chcesz dodać kierowcę mimo to?',
            icon: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'Nie',
            confirmButtonText: 'Tak'
          })

          if (dialogResult.isConfirmed) {
            const postData = {
              drivers: [driverId],
              skipValidation: true
            }
            await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Drivers`, postData, config)
            await Swal.fire('Dodano kierowcę do kolejnego zlecenia', '', 'success')
            emitter.emit('taskChanged', { taskId: this.task.id })
          }
        }
      }
    },
    async detachDrivers (taskId, driverId) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const task = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${taskId}`, config)).data
      const postData = {
        drivers: [
          driverId
        ]
      }
      try {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${task.id}/Drivers/Unassign`, postData, config)
        await Swal.fire('Odpięto kierowców od zlecenia', '', 'success')
        emitter.emit('taskChanged', { taskId: this.task.id })
      } catch (e) {
        console.log(e)
        await Swal.fire('Coś poszło nie tak', '', 'error')
      }
    },

    async detachTeam () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = { drivers: this.drivers.map(d => d.id) }

      const dialogResult = await Swal.fire({
        title: `Czy na pewno odpiąć obsadę od zlecenia ${this.task.numer_Przejazdu}`,
        showCancelButton: true,
        cancelButtonText: 'Anuluj',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        icon: 'question'
      })

      if (dialogResult.isConfirmed) {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Drivers/Unassign`, postData, config)
        await Swal.fire(`Odpięto obsadę od zlecenia ${this.task.numer_Przejazdu}`, 'Obsada została pomyślnie odpięta', 'success')
        emitter.emit('taskChanged', { taskId: this.task.id })
      }
    },
  }
}
</script>
